<template>
  <div v-loading="loading" class="page-form">
    <h3 class="title">发货仓启运设置</h3>

    <div class="table-container">
      <TableCommon title="明细信息" :custome-config="() => vxeShowCustom('xTable')">
        <template #button>
          <table-button name="add" tip="增加" @click="insertData" />
          <table-button name="save" tip="保存" @click="saveData" />
          <table-button name="delete" tip="删除" @click="removeData" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #saleCenter="{ row }">
            <el-input
              v-model="row['saleCenter']"
              placeholder="请选择"
              size="mini"
              suffix-icon="el-icon-more"
              @focus="openDialog($event, '营销中心', row)"
            />
          </template>
          <template #zqdlx="{ row }">
            <el-select v-model="row.zqdlx">
              <el-option
                v-for="item in selectDataOptions['goodsPlanType']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </template>
          <template #productNames="{ row }">
            <el-input
              v-model="row['productNames']"
              placeholder="请选择"
              size="mini"
              suffix-icon="el-icon-more"
              @focus="openDialog($event, '产品选择', row)"
            />
          </template>
          <template #warehouse="{ row }">
            <el-select v-model="row.warehouseCode" @change="onWarehouseChange">
              <el-option
                v-for="item in warehouseList"
                :key="item.warehouseCode"
                :label="item.warehouse"
                :value="item.warehouseCode"
              />
            </el-select>
          </template>
          <template #freightPrice="{ row }">
            <el-input v-model="row.freightPrice" type="number" />
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <org-select v-if="dialogTitle === '营销中心'" ref="dialogSelect" />
        <product-select v-if="dialogTitle === '产品选择'" ref="dialogSelect" />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiFindWarehouse, apiFindShippingFeeAdd } from '@/api/applyForGoods/shippingfee'
import { mapGetters } from 'vuex'
const OrgSelect = () => import('@/components/dialog/OrgSelect.vue')
const ProductSelect = () => import('@/components/dialog/ProductSelect.vue')

const rules = {}

export default {
  components: { OrgSelect, ProductSelect },
  data() {
    return {
      rules,
      loading: false,
      dialogTitle: '',
      showDialog: false,
      warehouseList: [],
      conditions: {
        id: '',
        bizId: '',
        taskId: '',
        zyear: '',
        p: '',
        partner: '',
        status: 0,
        billCode: '',
        partnerName: '',
        customerType: '',
        createdDate: '',
        createdByName: '',
        ztcrmTgpplanM1List: []
      },
      selectDataOptions: {},
      currentRow: null,
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { field: 'saleCenter', title: '营销单元', width: 120, slots: { default: 'saleCenter' }},
          { field: 'zqdlx', title: '渠道', width: 120, slots: { default: 'zqdlx' }},
          {
            field: 'productNames',
            title: '产品名称',
            width: 120,
            slots: { default: 'productNames' }
          },
          { field: 'warehouse', title: '仓库', width: 120, slots: { default: 'warehouse' }},
          { field: 'shipcityname', title: '所属城市', width: 120 },
          {
            field: 'freightPrice',
            title: '运费单价',
            width: 120,
            slots: { default: 'freightPrice' }
          }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['role'])
  },
  created() {
    this.getSelectDictDataOrigin('goodsPlanType')
  },
  methods: {
    openDialog(e, title, currentRow) {
      e.target.blur()
      this.showDialog = true
      this.dialogTitle = title
      currentRow && (this.currentRow = currentRow)
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()

      if (!data) return
      if (this.dialogTitle === '产品选择') {
        this.currentRow.productIds = data.productId
        this.currentRow.productNames = data.productShortName
      } else {
        this.currentRow.saleCenterName = data.name
        this.currentRow.saleCenter = data.code
        const res = await apiFindWarehouse({ saleCenter: data.code })
        this.warehouseList = res.data?.Rows
        if (this.warehouseList.length > 0) {
          this.currentRow.shipcityname = this.warehouseList[0].shipcityname
        }
      }
      this.showDialog = false
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    onWarehouseChange(e, row) {
      try {
        const warehouse = row.warehouseList.find(v => v.warehouseCode === e)
        row.warehouse = warehouse.warehouse
        row.shipcityname = warehouse.shipcityname
      } catch (e) {
        row.warehouse = ''
        row.shipcityname = ''
      }
    },
    insertData() {
      this.gridOptions.data.unshift({})
    },
    async removeData() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()
      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    saveData() {
      this.loading = true
      const params = JSON.parse(JSON.stringify(this.gridOptions.data))
      apiFindShippingFeeAdd(params)
        .then(response => {
          this.loading = false
          this.$message.success('保存成功')
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 10px;
  text-align: left;
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/deliveryFeeSetting.vue